/*

? First, let's import the interface that will describe the shape of our boost object.

*/

import StateInterface from "../state-interface";

export const ai_boost_meta_campaign: StateInterface["ai_boost_meta_campaign"] = {
    _id: "",
    campaign_id: "",
    name: "",
    status: "",
    buying_type: "",
    objective: "",
    special_ad_categories: [],
    bid_strategy: "",
    campaign_budget_optimization: false,
    daily_budget: 0,
    boost_id: "",
    property_id: "",
    mcp_stage: "",
    mcp_status: "",
    is_deleted: false,
    deleted_at: new Date().toISOString(),
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString(),
    last_optimized_at: new Date().toISOString(),
    last_optimization_action: "",
    last_optimization_remarks: "",
}